import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { ThunkExtra } from '@app/store';
import {
  DashboardService,
  GetUserWidgetAbsencesResponse,
} from '@app/gen/dashboard';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../../dashboard.state';

export const getAbsencesWidgetData = createAsyncThunk<
  GetUserWidgetAbsencesResponse,
  undefined,
  ThunkExtra
>(
  'dashboard/getAbsencesWidgetData',
  async (_, { rejectWithValue, extra: { inject } }) => {
    try {
      const service = inject(DashboardService);

      const result = await service.getUserWidgetAbsences();

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const absencesReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getAbsencesWidgetData.pending, (state) => {
    state.absences.status = 'loading';
  });
  builder.addCase(getAbsencesWidgetData.fulfilled, (state, { payload }) => {
    state.absences.status = 'complete';
    state.absences.items = payload.absences || [];
    state.absences.isManager = payload.is_manager || false;
  });
  builder.addCase(getAbsencesWidgetData.rejected, (state) => {
    state.absences.status = 'failed';
  });
};
